import { call } from '@redux-saga/core/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  isMaklerbetreuerOrMaklerOrUvm,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import { race, select, take, takeLatest } from 'redux-saga/effects';
import { OnboardingVideoRequestModel, SparteAntrag } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { Produkt } from '../model';
import { isHiddenOnboardingVideoApp } from '../selector/transient-state.selector';
import {
  ANTRAG_EINREICHEN_POLLING_EVENTS,
  CAP_UPLOAD_EVENTS,
} from './pollingHelper/polling-events';

const isEligibleForOnboardingVideo = (product: Produkt): boolean =>
  !isHiddenOnboardingVideoApp(product.appId) && !product.beibehalten;

export enum ONBOARDINGVIDEO_REQUEST_EVENTS {
  ONBOARDINGVIDEO_REQUEST_SUCCESSFUL = 'ONBOARDINGVIDEO_REQUEST_SUCCESSFUL',
  ONBOARDINGVIDEO_REQUEST_FAILED = 'ONBOARDINGVIDEO_REQUEST_FAILED',
}

export function* watchOnboardingVideo() {
  yield takeLatest(
    GlobalActions.VORSCHLAGDATEN_REQUESTED,
    safeSaga(onboardingVideo, App.SHOP_CHECKOUT),
  );
}

export function* onboardingVideo() {
  const state: IAppState = yield select();

  if (
    !state.transientState.onboardingVideo ||
    isMaklerbetreuerOrMaklerOrUvm(state.transientState.role)
  ) {
    return;
  }
  const globalPut = GlobalPut.getInstance();

  const onboardingVideoBody: OnboardingVideoRequestModel = {
    applicationIds: [],
    email: state.versicherungsnehmer.email?.wert,
  };

  const angebotsIdsForVideo = new Set(
    state.produkte
      .filter(isEligibleForOnboardingVideo)
      .map(p => p.angebotsId)
  );

  for (const _produkt of state.produkte) {
    const vorschlagsdatenAction: GlobalAction<SparteAntrag> = yield take(
      GlobalActions.VORSCHLAGDATEN_GENERATED,
    );
    if (vorschlagsdatenAction.payload?.antragsId &&
      angebotsIdsForVideo.has(vorschlagsdatenAction.payload.angebotsId)) {
      onboardingVideoBody.applicationIds.push(vorschlagsdatenAction.payload.antragsId);
    }
  }

  if (onboardingVideoBody.applicationIds.length < 1) {
    return;
  }

  yield race({
    telefonverkauf: take(ANTRAG_EINREICHEN_POLLING_EVENTS.SUCCESSFUL),
    cap: take(CAP_UPLOAD_EVENTS.UPLOAD_SUCCESSFUL),
  });

  const url = '/privatschutz/api/onboardingVideo';
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      url,
      body: onboardingVideoBody,
      successEvent: ONBOARDINGVIDEO_REQUEST_EVENTS.ONBOARDINGVIDEO_REQUEST_SUCCESSFUL,
      errorEvent: ONBOARDINGVIDEO_REQUEST_EVENTS.ONBOARDINGVIDEO_REQUEST_FAILED,
    }),
  );
}
